var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("nav", {
      staticClass:
        "bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0",
      staticStyle: { height: "50px" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-col md:flex-row" }, [
      _c(
        "div",
        { staticClass: "main-content flex-1 bg-gray-100 mt-12 md:mt-2" },
        [
          _c(
            "div",
            { staticClass: "bg-blue-800 p-2 shadow text-xl text-white" },
            [
              _c(
                "div",
                { staticClass: "bg-grey-lighter min-h-screen flex flex-col" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-white px-6 pt-4 pb-8 rounded shadow-md text-black w-full",
                          staticStyle: { width: "600px" }
                        },
                        [
                          _c("img", {
                            staticClass: "m-auto mb-10",
                            staticStyle: { width: "150px" },
                            attrs: {
                              src: require("@/assets/musicverse-logo.png")
                            }
                          }),
                          _vm._v(" "),
                          !_vm.error
                            ? _c(
                                "h2",
                                { staticClass: "mb-8 text-xl text-left" },
                                [
                                  _vm._v(
                                    "\n                We have sent an email with a confirmation link to your email address. Please click the confirmation link."
                                  ),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(
                                    "\n                If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form."
                                  ),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(
                                    "\n                If you still didn't receive the confirmation email to " +
                                      _vm._s(this.email) +
                                      " , click "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "text-blue-400 cursor-pointer",
                                      on: { click: _vm.nextProcess }
                                    },
                                    [_vm._v("here")]
                                  ),
                                  _vm._v(" to resend.\n              ")
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.error
                            ? _c(
                                "h1",
                                { staticClass: "mb-8 text-3xl text-center" },
                                [_vm._v("Sorry!")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.error
                            ? _c(
                                "h2",
                                { staticClass: "mb-8 text-xl text-left" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.error) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.error
                            ? _c(
                                "h1",
                                { staticClass: "mb-8 text-center" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "text-blue-400 cursor-pointer",
                                      attrs: { to: { name: "Signin" } }
                                    },
                                    [_vm._v("back to login page")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm.isEmailHasBeenSend
      ? _c(
          "div",
          {
            staticClass: "fixed bottom-0 right-0 m-8 w-5/6 md:w-full max-w-sm",
            on: {
              click: function($event) {
                return _vm.toggleToast()
              }
            }
          },
          [
            _c("input", {
              staticClass: "hidden",
              attrs: { type: "checkbox", id: "footertoast" }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass:
                  "close cursor-pointer flex items-start justify-between w-full p-2  bg-green-500 h-24 rounded shadow-lg text-white",
                attrs: { title: "close", for: "footertoast" }
              },
              [
                _vm._v("\n      Email has been sent\n\n      "),
                _c(
                  "svg",
                  {
                    staticClass: "fill-current text-white",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                      }
                    })
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ffb247d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ffb247d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SendVerification.vue
// module id = null
// module chunks = 